import React, { useState, useEffect } from "react";
import {Typography, Grid, InputBase, Button,} from "@material-ui/core";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import { SearchOutlined as SearchIcon } from "@material-ui/icons";
import useStyles from "./styles";
import { withSnackbar } from "../../../../../../components/Message/Alert";
import { ActionDialog } from "../../../../../../components/ActionDialog/ActionDialog";
import pic1 from '../../../../../../assets/img/BD.png';
import pic2 from '../../../../../../assets/img/BTDD.png';
import pic3 from '../../../../../../assets/img/HEP.png';
import pic4 from '../../../../../../assets/img/HFS.png';


const CustomCard = ({ ...props }) => {
    const classes = useStyles();
    const [actiondialogState, setActionDialogState] = useState({
        showHide: false,
        type: "confirm",
        message: "",
    });
    const [dcData, setDcData] = useState([pic1, pic2, pic3, pic4,pic1, pic2, pic3, pic4,pic1, pic2, pic3, pic4,pic1, pic2, pic3, pic4,]);
    useEffect(() => {
    }, []);
    return (
        <>
            <Grid container className={classes.gridHeader}>
                <Typography variant="h5" className={classes.GridHeading}>
                    Photo Gallery
                </Typography>
                <div className={"HeaderDialog"}>
                    <div className={classes.gridActions}>
                        <Button className={classes.changeBtn}>
                            <AddCircleOutlineIcon style={{ marginRight: "6px" }} /> Add Photo
                        </Button>
                    </div>
                    <div className={classes.gridActions} style={{ marginRight: "7px" }}>
                        <InputBase
                            placeholder="Search"
                            className="grid-search-input"
                            // endAdornment={searchQuery ? <ClearIcon style={{ cursor: 'pointer' }} onClick={() => { handleClearInput('search') }} /> : ''}
                            startAdornment={<SearchIcon />}
                            // value={searchQuery}
                            // onChange={handleSearchChange}
                        />
                    </div>
                </div>
            </Grid>
            <div className={classes.DocMainDiv}>
                <Grid container spacing={2}>
                    {dcData.map((item) => (
                        <Grid
                            item
                            xs={12}
                            sm={12}
                            md={6}
                            lg={3}
                            key={item.id}
                            className={classes.CardGrid}
                        >
                            <div className={classes.Card}>
                                <img src={item}/>
                            </div>
                        </Grid>
                    ))}
                </Grid>
            </div>
            <ActionDialog
                type={actiondialogState.type}
                message={actiondialogState.message}
                actiondialogOpenClose={actiondialogState.showHide}
                onSubmit={actiondialogState.onClickOk}
                onCancel={() =>
                    setActionDialogState((prevState) => ({
                        ...prevState,
                        showHide: false,
                    }))
                }
                onClose={() =>
                    setActionDialogState((prevState) => ({
                        ...prevState,
                        showHide: false,
                    }))
                }
            />
            <ActionDialog
                type={actiondialogState.type}
                message={actiondialogState.message}
                actiondialogOpenClose={actiondialogState.showHide}
                onSubmit={actiondialogState.onClickOk}
                onCancel={() =>
                    setActionDialogState((prevState) => ({
                        ...prevState,
                        showHide: false,
                    }))
                }
                onClose={() =>
                    setActionDialogState((prevState) => ({
                        ...prevState,
                        showHide: false,
                    }))
                }
            />
        </>
    );
};

export default withSnackbar(CustomCard);
